/** @jsx onetext.jsx.element */

import type { OneText } from '../../../global';

// eslint-disable-next-line no-restricted-syntax
import {
    Balloon01_1, Balloon02_1, Balloon03_1, Balloon06, BirthdayCap01,
    BirthdayCap02, BirthdayCap03, Camera, Crown, Envelope,
    Garland01, Garland02, Gift01, Gift02, Heart01,
    Heart02, Ribbon02, Serpentine01, Serpentine02, Serpentine03
} from '../images';

declare let onetext : OneText;

const { clsx } = onetext.jsx;

export const BrandBackgroundBirthday = () : JSX.Element => (
    <div className={ 'absolute inset-0 overflow-hidden' }>
        { /* Top Left */ }
        <img
            src={ Garland01 }
            className={
                clsx(
                    'absolute',
                    'top-[-20px] left-[-20px] w-[240px]',
                    'md:w-[300px]',
                    'transform rotate-[-15deg]'
                )
            } />
        <img
            src={ Balloon01_1 }
            className={
                clsx(
                    'absolute',
                    'top-[-20px] left-[10px] w-[60px]',
                    'md:top-[-25px] md:left-[20px] md:w-[80px]',
                    'transform rotate-[15deg]'
                )
            } />
        <img
            src={ BirthdayCap01 }
            className={
                clsx(
                    'absolute',
                    'top-[8%] left-[20px] w-[40px]',
                    'md:top-[10%] md:left-[30px] md:w-[70px]',
                    'transform rotate-[10deg]'
                )
            } />
        <img
            src={ Camera }
            className={
                clsx(
                    'absolute',
                    'top-[20%] left-[2%] w-[50px]',
                    'md:top-[23%] md:left-[3%] md:w-[70px]',
                    'transform rotate-[-5deg]'
                )
            } />
        <img
            src={ Envelope }
            className={
                clsx(
                    'absolute',
                    'top-[12%] left-[7%] w-[45px]',
                    'md:top-[15%] md:left-[9%] md:w-[65px]',
                    'transform rotate-[-10deg]'
                )
            } />
        <img
            src={ Gift02 }
            className={
                clsx(
                    'absolute',
                    'top-[18%] left-[12%] w-[50px]',
                    'md:top-[12%] md:left-[15%] md:w-[70px]',
                    'transform rotate-[10deg]'
                )
            } />

        { /* Top Right */ }
        <img
            src={ Garland02 }
            className={
                clsx(
                    'absolute',
                    'top-[-20px] right-[-20px] w-[240px]',
                    'md:w-[300px]',
                    'transform rotate-[30deg]'
                )
            } />
        <img
            src={ Balloon02_1 }
            className={
                clsx(
                    'absolute',
                    'top-[10px] right-[30px] w-[90px]',
                    'md:top-[20px] md:right-[40px] md:w-[120px]',
                    'transform rotate-[-10deg]'
                )
            } />
        <img
            src={ BirthdayCap02 }
            className={
                clsx(
                    'absolute',
                    'top-[15%] right-[5%] w-[35px]',
                    'md:top-[18%] md:right-[7%] md:w-[85px]',
                    'transform rotate-[-15deg]'
                )
            } />
        <img
            src={ Heart01 }
            className={
                clsx(
                    'absolute',
                    'top-[22%] right-[8%] w-[40px]',
                    'md:top-[30%] md:right-[10%] md:w-[60px]'
                )
            } />
        <img
            src={ Serpentine03 }
            className={
                clsx(
                    'absolute',
                    'top-[20%] right-[2%] w-[75px]',
                    'md:top-[23%] md:right-[-1%] md:w-[195px]'
                )
            } />

        { /* Bottom Left */ }
        <img
            src={ Balloon03_1 }
            className={
                clsx(
                    'absolute',
                    'bottom-[20px] left-[5%] w-[55px]',
                    'md:bottom-[80px] md:left-[-2%] md:w-[125px]',
                    'transform rotate-[5deg]'
                )
            } />
        <img
            src={ BirthdayCap03 }
            className={
                clsx(
                    'absolute',
                    'bottom-[12%] left-[8%] w-[45px]',
                    'md:bottom-[15%] md:left-[10%] md:w-[75px]',
                    'transform rotate-[20deg]'
                )
            } />
        <img
            src={ Serpentine02 }
            className={
                clsx(
                    'absolute',
                    'bottom-[5%] left-[10%] w-[70px]',
                    'md:bottom-[7%] md:left-[12%] md:w-[120px]'
                )
            } />
        <img
            src={ Heart02 }
            className={
                clsx(
                    'absolute',
                    'bottom-[2%] left-[20%] w-[35px]',
                    'md:bottom-[3%] md:left-[23%] md:w-[55px]',
                    'transform rotate-[-15deg]'
                )
            } />

        { /* Bottom Right */ }
        <img
            src={ Serpentine01 }
            className={
                clsx(
                    'absolute',
                    'bottom-[5%] right-[15%] w-[80px]',
                    'md:bottom-[7%] md:right-[7%] md:w-[100px]',
                    'transform rotate-[15deg]'
                )
            } />
        <img
            src={ Balloon06 }
            className={
                clsx(
                    'absolute',
                    'bottom-[8%] right-[5%] w-[45px]',
                    'md:bottom-[20%] md:right-[-1%] md:w-[120px]',
                    'transform rotate-[-25deg]'
                )
            } />
        <img
            src={ Crown }
            className={
                clsx(
                    'absolute',
                    'bottom-[10%] right-[3%] w-[40px]',
                    'md:bottom-[12%] md:right-[4%] md:w-[120px]',
                    'transform rotate-[15deg]'
                )
            } />
        <img
            src={ Gift01 }
            className={
                clsx(
                    'absolute',
                    'bottom-[5%] right-[15%] w-[55px]',
                    'md:bottom-[7%] md:right-[18%] md:w-[75px]',
                    'transform rotate-[-20deg]'
                )
            } />
        <img
            src={ Ribbon02 }
            className={
                clsx(
                    'absolute',
                    'bottom-[12%] right-[12%] w-[50px]',
                    'md:bottom-[15%] md:right-[15%] md:w-[70px]',
                    'transform rotate-[-10deg]'
                )
            } />
    </div>
);
